export function getEntryStyle(type, options = {}) {
	const opts = Object.assign(
		{
			outline: false,
			lighten: 0,
		},
		options,
	)
	var res = null
	if (type === 'event')
		res = {
			color: 'deep-orange',
			icon: 'mdi-bell',
		}
	else if (type === 'task')
		res = {
			color: 'light-blue',
			icon: 'mdi-clock',
		}
	else if (type === 'interval') {
		res = {
			color: 'blue-grey',
			icon: 'mdi-dots-horizontal-circle-outline',
		}
	}
	if (opts.outline) res.icon = res.icon + '-outline'
	if (opts.lighten > 0) {
		res.color = ` lighten-${opts.lighten} ` + res.color
	}
	return res
}
